import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, FormControlLabel, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { Arbitrator, AttributeModiferKeys } from './Arbitrator';
const INITIAL = 0;
export const BitmapAttribute = (props) => {
    const { name, attribute, rangeLimits, disable, isRoot } = props;
    const [checked, setChecked] = useState(false);
    const [value, setValue] = useState(INITIAL);
    const disabled = isRoot ? !checked : disable;
    useEffect(() => {
        if (disabled)
            setChecked(false);
        if (value !== INITIAL && disabled)
            setValue(INITIAL);
    }, [disabled, value]);
    const more = [];
    const payload = {};
    let valid = !disabled;
    const { attributeType, bitmap, ...others } = rangeLimits;
    for (const [key, other] of Object.entries(others)) {
        if (!AttributeModiferKeys.includes(key)) {
            const { elements, payload: p, valid: v, } = Arbitrator({
                name: key,
                attribute,
                rangeLimits: other,
                disable: isRoot && !checked,
                isRoot: false,
            });
            more.push(elements);
            payload[name] ??= {};
            if (p[key] !== undefined)
                payload[name][key] = p[key];
            valid = valid && v;
        }
    }
    const options = Object.keys(bitmap);
    if (!disabled && value)
        payload[name] = value;
    valid = valid && value !== INITIAL;
    const present = isRoot && _jsx(Checkbox, { checked: checked, onChange: (e) => setChecked(e.target.checked), disabled: disable });
    const control = (_jsx(Stack, { gap: 0.5, children: options.map((k, i) => {
            const v = 1 << i;
            return (_jsx(FormControlLabel, { label: k, disabled: disabled, sx: { paddingInlineStart: 1, gap: 0.5 }, control: _jsx(Checkbox, { checked: value & v ? true : false, onChange: (_, checked) => {
                        if (checked) {
                            setValue((val) => val | v);
                        }
                        else {
                            setValue((val) => val & ~v);
                        }
                    }, size: "small", sx: { padding: 0 } }) }, k));
        }) }));
    const elements = more.length ? (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [present, control, _jsxs(Stack, { gap: 1, children: [...more] })] })) : (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [present, control] }));
    return { elements, payload, valid };
};
